module.exports = __webpack_public_path__ + "static/media/user.acef90cf.svg";